web-visibility-trigger {
    position: absolute;
    top: 0;
}
